export const handleTabToNextEditableCell = ({
  params,
  nextColKey,
  prevColKey,
}) => {
  const { event, api, rowIndex } = params;

  if (event.key !== 'Tab') return;

  event.preventDefault();
  api.stopEditing();

  const targetCol = event.shiftKey ? prevColKey : nextColKey;
  if (!targetCol) return;

  setTimeout(() => {
    api.startEditingCell({
      rowIndex,
      colKey: targetCol,
    });
  }, 0);
};
